<template>
    <div class="folder" @click.stop="onFolderClick(folder)" 
      v-context-menu="{action: onContextMenu, data: folder}">
        <span v-if="folder.childs"
          @click.stop="onFolderToggleCollapse(folder)"
          class="sub-menu-icon"
          role="button"
        >
            <i
                class="fas"
                :class="folders_collapse_collection.collapsed[folder.id] ? 'fa-chevron-right' : 'fa-chevron-down'"
            >
            </i>
        </span>

        <router-link :to='"/messages/" + folder.id' v-if="list_type === 'router'">
            <span class="menu-icon" :data-tooltip-visible="props.show_tooltips" v-tooltip="folder.name">
                <i :class="folder.icon"></i>
            </span>
            <span class="menu-title">{{folder.name}}</span>
            <span v-if="folder.unread" class="counter">{{folder.unread}}</span>
        </router-link>

        <div v-else>
            <span class="menu-icon">
                <i :class='folder.icon'></i>
            </span>
            <span class="menu-title">{{folder.name}}</span>
        </div>
    </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';

  const emit = defineEmits([
    'folderToggleCollapse', 'folderClick', 'folderContextMenu'
  ])

  const props = defineProps({
    folders_collapse_collection : {},

    list_type : {
      default : 'router'
    },

    folder : {
      required: true,
    },

    show_tooltips : {
      default : false,
    }
  })

  const onFolderToggleCollapse = (folder) => {
    emit('folderToggleCollapse', folder);
  }

  const onFolderClick = (folder) => {
    emit('folderClick', folder);
  }

  const onContextMenu = (folder) => {    
    emit('folderContextMenu', folder);
  }
</script>